import { api } from "../api/client";
import { RecruiterReviewRequest, RecruiterReviewResponse } from "../types/recruiterReview";

export const useRecruiterReviewService = () => {
    const runRecruiterReview = async (req: RecruiterReviewRequest): Promise<RecruiterReviewResponse> => {
        const resp = await api.post('/api/RecruiterReview/Analyze', req);
        return resp.data;
    };

    return { runRecruiterReview };
};
